"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourEditorButton = void 0;
const react_1 = require("@thesisedu/react");
const react_2 = __importDefault(require("react"));
const TourEditor_1 = require("./TourEditor");
function TourEditorButton({ value, onChange }) {
    const [visible, setVisible] = react_2.default.useState(false);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.Modal, { title: 'Edit Tour', visible: visible, onCancel: () => setVisible(false), width: 800, style: { maxWidth: '90vw' } },
            react_2.default.createElement(TourEditor_1.TourEditor, { value: value, onChange: changes => {
                    if (onChange) {
                        setVisible(false);
                        onChange(changes);
                    }
                } })),
        react_2.default.createElement(react_1.HSpaced, null,
            react_2.default.createElement(react_1.Body, null,
                (value === null || value === void 0 ? void 0 : value.steps.length) || 0,
                " step",
                (value === null || value === void 0 ? void 0 : value.steps.length) === 1 ? '' : 's'),
            react_2.default.createElement(react_1.Space, null),
            react_2.default.createElement(react_1.Button, { children: 'Edit Tour', onClick: e => {
                    e.preventDefault();
                    setVisible(true);
                } }))));
}
exports.TourEditorButton = TourEditorButton;
//# sourceMappingURL=TourEditorButton.js.map